import { ProfileType } from '../../../common/enums/ProfileType';
import { ThresholdInfoMap, ThresholdRule } from './Threshold';
import { Profile } from './valueObjects/Profile';

export class TracerProfile extends Profile {
  constructor(
    id: number,
    name: string,
    type: ProfileType,
    preset: boolean,
    disabledRulesNumbers: Set<number>,
    private readonly ecInfo: number[] | null,
    private readonly rsaInfo: number[] | null,
    private readonly staleKeyInfo: number[] | null,
    private readonly certificateValidityInfo: number[] | null,
    private readonly symmetricInfo: number[] | null,
    private readonly expiringSoon: number
  ) {
    super(id, name, type, preset, disabledRulesNumbers);
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getType() {
    return this.type;
  }

  getDisableRulesNumbers() {
    return this.disabledRulesNumbers;
  }

  getEcInfo() {
    return this.ecInfo;
  }
  getRsaInfo() {
    return this.rsaInfo;
  }

  getStaleKeyInfo() {
    return this.staleKeyInfo;
  }

  getCertificateValidityInfo() {
    return this.certificateValidityInfo;
  }

  getSymmetricInfo() {
    return this.symmetricInfo;
  }

  getExpiringSoon() {
    return this.expiringSoon;
  }

  static blank() {
    return new TracerProfile(
      0,
      '',
      ProfileType.TRACER,
      false,
      new Set(),
      ThresholdInfoMap[ThresholdRule.EC].defaultValues,
      ThresholdInfoMap[ThresholdRule.RSA].defaultValues,
      ThresholdInfoMap[ThresholdRule.STALE_KEY_202].defaultValues,
      ThresholdInfoMap[ThresholdRule.CERT_VALIDITY].defaultValues,
      ThresholdInfoMap[ThresholdRule.SYMMETRIC].defaultValues,
      14
    );
  }
}
